import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TypedFormGroup } from 'gandalf';
import { CategoryResponseForDropdown } from '@core/category/category.service';
import { TaskPriority } from '@gandalf/constants';
import { CreateTaskRequest } from '@gandalf/model/create-task-request';
import { DATE_FORMATS } from '@shared/constants/date-format.constants';
import { SharedModule } from '@shared/shared.module';
import { AssigneeSelection, TaskAssigneePickerComponent } from '../task-assignee-picker/task-assignee-picker.component';

@Component({
	selector: 'pms-task-form-fields',
	templateUrl: './task-form-fields.component.html',
	standalone: true,
	imports: [
		CommonModule,
		ReactiveFormsModule,
		SharedModule,
		TaskAssigneePickerComponent,
	],
})
export class TaskFormFieldsComponent {
	@Input() form: TypedFormGroup<CreateTaskRequest>;
	@Input() categories: CategoryResponseForDropdown[] = [];
	@Input() disableCategorySelect = false;
	@Input() disablePatientSelect = false;
	@Input() hideNavigateToPatient = false;
	@Input() testIdPrefix = 'task';

	dateFormat = DATE_FORMATS.MM_DD_YYYY;
	taskPriorityOptions = TaskPriority.VALUES;

	@Input() initialSelectedPersonIds: number[] = [];
	@Input() initialRequireAll = false;
	@Input() initialRoleId: number = null;

	@Output() assigneeSelectionChanged = new EventEmitter<AssigneeSelection>();

	onAssigneeSelectionChanged(selection: AssigneeSelection) {
		const noEmit = { emitEvent: false };
		if (selection.selectedPersonIds.length === 1 && !selection.requireAll) {
			this.form.controls.assigneePersonId.setValue(selection.selectedPersonIds[0], noEmit);
			this.form.controls.assignToAll.setValue(false, noEmit);
			this.form.controls.optionalAssigneePersonIds.setValue([]);
		} else if (selection.selectedPersonIds.length > 0) {
			this.form.controls.assigneePersonId.setValue(null, noEmit);
			this.form.controls.assignToAll.setValue(selection.requireAll, noEmit);
			this.form.controls.optionalAssigneePersonIds.setValue(selection.selectedPersonIds);
		} else {
			this.form.controls.assigneePersonId.setValue(null, noEmit);
			this.form.controls.assignToAll.setValue(false, noEmit);
			this.form.controls.optionalAssigneePersonIds.setValue([]);
		}
		this.assigneeSelectionChanged.emit(selection);
	}
}
